<template>
  <div class="container-button-add--section py-2 my-3">
    <hr class="button-add--section--line">

    <button 
      v-b-tooltip.hover
      title="Criar Seção"
      @click.prevent="handleClick"
      class="button-add--section"
    >
      <i class="fal fa-plus mr-2 mr-md-0"></i>

      <span class="d-block d-md-none">
        Criar Seção
      </span>
    </button>

    <modal-preset-frames
      size="xl"
      title="Criar Seção"
      :filters="filters"
      :show="this.showModalPresetFrames"
      textButtonPrimary="Criar"
      textButtonClose="Cancelar"
      @handleButtonPrimary="handleCreate"
      @handleButtonClose="() => this.showModalPresetFrames = false"
    />
  </div>
</template>

<script>
import apiMixins from "@/mixins/apiMixins";
import ModalPresetFrames from '../organisms/ModalPresetFrames.vue';

export default {
  components: { 
    ModalPresetFrames
  },
  name: "AddSection",
  data() {
    return {
      filters: [
        {
          id: 1,
          name: 'Todos',
          type: '',
        },
        {
          id: 2,
          name: 'Texto',
          type: 'text',
        },
        {
          id: 3,
          name: 'Imagem',
          type: 'image',
        },
        {
          id: 4,
          name: 'Galeria',
          type: 'gallery',
        },
        {
          id: 5,
          name: 'Botão',
          type: 'button',
        }
      ],
      showModalPresetFrames: false,
    };
  },
  mixins: [apiMixins],
  methods: {
    handleClick() {
      this.$emit("return-slot", this.slotNum);

      this.showModalPresetFrames = true;
    },
    handleCreate(activeSection) {
      this.$emit("create-section", activeSection);

      this.showModalPresetFrames = false;
    },
  },
  props: {
    slotNum: Number
  },
};
</script>

<style scoped>
.container-button-add--section {
  width: 100%;
  position: relative;
  border: none;
  background-color: transparent;
}

.button-add--section--line {
  border: 1px dashed #e5e5e5;
  width: 98%;
}

.button-add--section:hover  {
  background-color: var(--main-color);
  color: #ffffff;
}

.button-add--section {
  position: absolute;
  top: 25%;
  right: 0%;
  padding: 0;
  width: 24px;
  height: 24px;
  padding: .3rem;
  background-color: #e5e5e5;
  border: none;
  border-radius: 16px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  font-size: 14px;
}


@media (max-width: 768px) {
  .button-add--section {
    top: 15%;
    padding: .3rem .5rem;
    width: auto;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/AddSection.vue